import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { createSelector } from 'reselect'

import { DEFAULT_CURRENCY } from '../../lib'
import { getFinancialPlanQualityFromCockpitRows } from '../../lib/planningQuality'

import { selectCockpitActualsAndTargetsSettings } from './selectCockpitActualsAndTargetsSettings'
import { selectCockpitCategoriesByOffering } from './selectCockpitCategoriesByOffering'
import { selectCockpitCategory } from './selectCockpitCategory'
import { selectCockpitCurrency } from './selectCockpitCurrency'
import { selectCockpitFinancialPlanQualityByOffering } from './selectCockpitFinancialPlanQualityByOffering'
import { selectCockpitMetric } from './selectCockpitMetric'
import { selectCockpitOffering } from './selectCockpitOffering'
import { selectCockpitOfferingPresentation } from './selectCockpitOfferingPresentation'
import { selectCockpitPeriods } from './selectCockpitPeriods'
import { selectCockpitSobMandatoryContext } from './selectCockpitSobMandatoryContext'
import { selectEffectiveCockpitActualsSync } from './selectEffectiveCockpitActualsSync'
import { selectVisibleCockpitFinSobRows } from './selectVisibleCockpitFinSobRows'

export const selectCockpitFinancialPlanQualitySummary = createSelector(
  [
    selectCockpitFinancialPlanQualityByOffering,
    selectCockpitOffering,
    selectCockpitCategory,
    selectVisibleCockpitFinSobRows,
    selectEffectiveCockpitActualsSync,
    selectCockpitMetric,
    selectCockpitCurrency,
    selectCockpitPeriods,
    selectCockpitOfferingPresentation,
    selectCockpitCategoriesByOffering,
    selectCockpitActualsAndTargetsSettings,
    selectCockpitSobMandatoryContext,
  ],
  (
    qualityByOffering,
    selectedOffering,
    selectedCategory,
    rows,
    { fYear, currentFQuarter, fQuarterActualsPercentage },
    actualsType,
    currency,
    periods,
    offeringPresentation,
    categoriesByOffering,
    settings,
    sobMandatoryContext
  ) => {
    const selectedOfferingQuality =
      selectedOffering === ProgramTypes.Overall
        ? qualityByOffering.overallQuality
        : qualityByOffering.byOffering.get(selectedOffering)

    if (!selectedCategory && selectedOfferingQuality) {
      return { ...qualityByOffering, selectedQuality: selectedOfferingQuality }
    }

    const selectedQuality = getFinancialPlanQualityFromCockpitRows({
      rows,
      fYear,
      actualsType,
      isLocalCurrency: currency !== DEFAULT_CURRENCY,
      offering: selectedOffering === ProgramTypes.Overall ? undefined : selectedOffering,
      category: selectedCategory ?? null,
      periods,
      currentFQuarter,
      fQuarterActualsPercentage,
      offeringPresentation,
      categoriesByOffering,
      settings,
      sobMandatoryContext,
    })

    return { ...qualityByOffering, selectedQuality }
  }
)
